// Pages: Affiliates, Backup, Block Storage, Cloud VPS, DDoS Protection, Object Storage

$(function () {
    const questions = document.querySelectorAll('.question')

    questions.forEach((question) => {
        const title = question.querySelector('h3, h4')
        const answer = question.querySelector('.answer')

        // Add click event listener to the title
        title.addEventListener('click', () => {
            // Close all other accordions
            questions.forEach((q) => {
                if (q !== question) {
                    q.classList.remove('active')
                    q.querySelector('.answer').style.maxHeight = null
                }
            })

            // Toggle active class on current accordion
            question.classList.toggle('active')

            // Toggle max-height of answer element to expand/collapse
            if (question.classList.contains('active')) {
                answer.style.maxHeight = answer.scrollHeight + 'px'
            } else {
                answer.style.maxHeight = null
            }
        })
    })
})
